//
// ItemTitleSubtitle
//
// A component which returns either the label or the name
// based on the labelView parameter as the title and the opposite as the subtitle.
// If no label is found we use the name as the title and the subtitle.

import { observer } from 'mobx-react-lite'
import { useStore } from '../../stores'
import { formatItemLabel, formatItemName } from '../../stores/data/utils'
import { maxChars } from '../../utils/text'

export const ItemTitleSubtitle = observer(function ItemTitleSubtitle({
    item,
    ellipsisAfter,
    ...other
}) {
    const { app, view } = useStore()
    const labelView = view.environment.get('labelView')

    let title
    let subtitle
    if (labelView === 'labels') {
        title = formatItemLabel(item, view.language)
        if (!title) {
            title = formatItemName(item)
        }
        subtitle = item.name
    } else {
        title = formatItemName(item)
        subtitle = formatItemLabel(item, view.language)
        if (!subtitle) {
            subtitle = item.name
        }
    }

    if (!title.length && !subtitle.length) {
        title = app.text('[empty]')
    }

    let truncatedTitle = maxChars(title, ellipsisAfter)
    let truncatedSubtitle = maxChars(subtitle, ellipsisAfter)

    return (
        <div
            className="cc-ItemTitleSubtitle"
            title={title + '\n' + subtitle}
            {...other}
        >
            <div>{truncatedTitle}</div>
            <div className="cc-dimmed">{truncatedSubtitle}</div>
        </div>
    )
})
